import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { removeLegacyWizardDraft } from './module/wizard-draft';
import { platformAdminEntry } from './lib/platformAdminEntry';
import { CentralHandoff } from './pages/superadmin/CentralHandoff';

const root = createRoot(document.getElementById('root')!);
const path = window.location.pathname;

// Do not initialize the native auth store/refresh transport for central admin entries.
if (platformAdminEntry(import.meta.env.VITE_PLATFORM_ADMIN_ENABLED, path)) {
  root.render(<CentralHandoff path={path} />);
} else if (path === '/shared' || path.startsWith('/shared/')) {
  // Never start the native auth/refresh path for a shared-account session,
  // including disabled or unconfigured deployments.
  if (import.meta.env.VITE_CARTIQ_STANDALONE_ENABLED === 'true') {
    void import('./shared-session/SharedCartiqApp').then(({ SharedCartiqApp }) => {
      root.render(<StrictMode><SharedCartiqApp /></StrictMode>);
    }).catch(() => root.render(<p role="alert">Shared Cartiq could not load. Reload to try again.</p>));
  } else {
    root.render(<p role="alert">Standalone shared Cartiq is not enabled in this deployment.</p>);
  }
} else {
  removeLegacyWizardDraft();
  void import('./App').then(({ App }) => {
    root.render(<StrictMode><App /></StrictMode>);
  }).catch(() => {
    root.render(<p role="alert">Cartiq could not load. Reload this page to try again.</p>);
  });
}
